import React, { useEffect, useState, useRef } from "react";
import {
  Row,
  Col,
  Spin,
  List,
  Input,
  Avatar,
  Image,
  Modal,
  Button,
  Tabs,
} from "antd";
import {
  CheckCircleOutlined,
} from "@ant-design/icons";
import "./style.css";
import { useSelector, useDispatch } from 'react-redux';
import { Link, useLocation, useHistory } from "react-router-dom";
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import SignatureCanvas from 'react-signature-canvas';
import moment from 'moment';
import { getDocumentSeenStamp, getSignatureListAsyn, clearSignatureListState, DocumentSeenStampSelector, clearState, addInitials, unsetInitialAdded } from './DocumentSeenStampSlice';
import { authSelector } from '../Auth/authSlice';
const { TextArea } = Input;
const { TabPane } = Tabs;

const data = [
  {
    deptTypeName: 'CCIS',
    info: [],
  },
  {
    deptTypeName: 'CCIS',
    info: [],
  },
];


export default function DocumentSeenStamp() {
  const canvasRef = useRef<any>(null);
  const dispatch = useDispatch();
  let history = useHistory();
  const location = useLocation();
  const [isLoading, setLoading] = React.useState(false);
  const [remark, setRemark] = React.useState('');
  const [initial, setInitial] = React.useState('');
  const [SavedImageName, setSavedImageName] = React.useState('');

  const { isFetching, isStageDataSuccess, isError, isSignSuccess, SignData, zeroStage, cos_seenStamp, signCount, SignImagePath, errorMessage, stageData,preremarksData, imagePath, isInitialAdded } = useSelector(
    DocumentSeenStampSelector
  );

  const { user } = useSelector(
    authSelector
  );

  const [minutesStageData, setminutesStageData] = useState<any>([]);
  const [signatureData, setsignatureData] = useState<any>([]);

  useEffect(() => {
    setLoading(true);
    dispatch(clearState());
    dispatch(getDocumentSeenStamp(location.state.documentInfo.documentUpdatedData.processId));
    dispatch(getSignatureListAsyn());
  }, []);

  useEffect(() => {

    if (isError) {
      setLoading(false);
      toast.error(errorMessage);
    }
    if (isStageDataSuccess) {
      // setLoading(false);
      //  setminutesStageData(stageData);

      // console.log(preremarksData,'rdata')

    }
    if (isInitialAdded) {
      // console.log('initial added')
      setLoading(false);
      if (errorMessage === "This document has already been filed") {
        toast.error(errorMessage);
      }
      dispatch(unsetInitialAdded());
      dispatch(getDocumentSeenStamp(location.state.documentInfo.documentUpdatedData.processId));
    }

    if (isSignSuccess) {
      setsignatureData(SignData);
      dispatch(clearSignatureListState());
    }

  }, [isError, isStageDataSuccess, isSignSuccess, SignData, setLoading, unsetInitialAdded, stageData,preremarksData, imagePath, isInitialAdded]);


  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    if (!canvasRef.current?.isEmpty()) {
      // console.log(location.state.documentInfo.documentUpdatedData.processId)
      const simg = canvasRef.current?.getTrimmedCanvas().toDataURL('image/png');
      // console.log(simg)
      setInitial(simg);
      // const simg = canvasRef.current?.getTrimmedCanvas().toDataURL('image/png');
      // let image:any = new Image();
      // image.src = simg;
      // var bodyFormData = new FormData();
      // bodyFormData.append('initial', image); 
      // bodyFormData.append('processId', location.state.documentInfo.documentUpdatedData.processId);
      // bodyFormData.append('remarks', 'Fred');
      // dispatch(addInitials(bodyFormData));
      // console.log(simg)
    }

    canvasRef.current?.clear();
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    // canvasRef.current.clear();
    canvasRef.current?.clear();
    setIsModalVisible(false);
    setInitial('');
  };
  // ... Code for List populated Directly using ( DataSources Attribute inside List) -
  // - But Not worked as response is comming in multidimensional Array.....  

  // let MinStageApproverSource = minutesStageData && (minutesStageData as any).data ? (minutesStageData as any).data.map((row: any, key: any) => {

  //     row.map((current: any, index: any) => (
  //         {
  //             id: current._id,
  //             stage: current._id,
  //             fullName: current.fullName,
  //             status: current && current.signed && current.signed.length > 0 ? 'Signed' : 'Pending Sign',
  //         })
  //     );

  // })
  //     : [];

  const clearSignature = () => {
    canvasRef.current?.clear();
  };

  //  const DataURIToBlob = (dataURI: string)  => {
  //   const splitDataURI = dataURI.split(',')
  //   const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
  //   const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

  //   const ia = new Uint8Array(byteString.length)
  //   for (let i = 0; i < byteString.length; i++)
  //       ia[i] = byteString.charCodeAt(i)

  //   return new Blob([ia], { type: mimeString })
  // }


  const submitInitial = () => {

    let initialData = {
      // "initial": initial,
      "processId": location.state.documentInfo.documentUpdatedData.processId,
      "remarks": remark
    }

    if (SavedImageName) {
      initialData["initial"] = SavedImageName;
      initialData["newSign"] = false;
    }
    else { initialData["initial"] = initial; initialData["newSign"] = true; }
    // console.log(initialData);
    dispatch(addInitials(initialData));
    canvasRef.current?.clear();
    setIsModalVisible(false);
    //  var img:any = document.createElement('img');
    // img.src = initial;
    // img.onload = function () {
    //   // var bodyFormData = new FormData();
    //   // bodyFormData.append('initial', img); 
    //   // bodyFormData.append('processId', location.state.documentInfo.documentUpdatedData.processId);
    //   // bodyFormData.append('remarks', remark);
    //   // console.log(bodyFormData)

    //  }
    // var formData = new FormData();
    // var imagefile:any = document.querySelector('#initialsimage');
    // formData.append('initial', imagefile); 
    // formData.append('processId', location.state.documentInfo.documentUpdatedData.processId);
    // formData.append('remarks', remark);
    //  dispatch(addInitials(formData));

    //  var formData = new FormData();
    //  const file = new File([initial], "intial.png");
    //  formData.append('initial', file)
    // formData.append('processId', location.state.documentInfo.documentUpdatedData.processId);
    // formData.append('remarks', remark);
    // dispatch(addInitials(formData));


    // }

    // var bodyFormData = new FormData();
    // bodyFormData.append('initial', img); 
    // bodyFormData.append('processId', location.state.documentInfo.documentUpdatedData.processId);
    // bodyFormData.append('remarks', remark);
    // console.log(bodyFormData)
    //  dispatch(addInitials(bodyFormData));

    // var img:any = document.createElement('img');
    // img.src = initial;
    // img.onload = function () {
    //   // let image:any = new Image();
    //   // image.src = initial;
    //   // var bodyFormData = new FormData();
    //   // bodyFormData.append('initial', img); 
    //   // bodyFormData.append('processId', location.state.documentInfo.documentUpdatedData.processId);
    //   // bodyFormData.append('remarks', remark);
    //   // console.log(bodyFormData)
    //   //  dispatch(addInitials(bodyFormData));
    //   // canvasRef.current?.clear();
    //   // setIsModalVisible(false);
    //  }


  }


  function onChnageTabInModal(key) {
    // console.log(key);
  }

  const handleAddSign = (e, value) => {
    e.preventDefault();
    // console.log("value => ", value);
    setInitial(value.base64);
    setSavedImageName('');
    setSavedImageName(value.base64)
    canvasRef.current?.clear();
    setIsModalVisible(false);
  }


  // console.log('stageData.data', stageData)

  const remarksdata = [
    {
      title: 'Ant Design Title 1',
    },
    {
      title: 'Ant Design Title 2',
    },
    {
      title: 'Ant Design Title 3',
    },
    {
      title: 'Ant Design Title 4',
    },
  ];

  return (
    <>
      <div className="two-different-list"
      // style={{ height: '500px', overflowY: 'auto' }}
      >
        <List
          style={{ width: '100%', paddingBottom: 10, paddingLeft: 5, paddingRight: 5 }}
          //style={{ height: '85vh', overflow: 'auto'}}
          itemLayout="horizontal"
          dataSource={stageData}
          header={<Row>
            <Col span={8} className=" tabletdpadding">
              <span style={{ fontSize: 16, fontWeight: 500, color: '#B4B4B4' }}>Appt</span>
            </Col>
            <Col span={5} className=" tabletdpadding">
              <span style={{ fontSize: 16, fontWeight: 500, color: '#B4B4B4' }}>Initials</span>
            </Col>
            <Col span={5} className=" tabletdpadding">
              <span style={{ fontSize: 16, fontWeight: 500, color: '#B4B4B4' }}>Date</span>
            </Col>
            <Col span={6} className=" tabletdpadding">
              <span style={{ fontSize: 16, fontWeight: 500, color: '#B4B4B4' }}>Remarks</span>
            </Col>
          </Row>}
          renderItem={(item: any) => (


            <List.Item style={{ marginBottom: 10, border: '1px solid #dfe0eb', padding: '15px 10px 15px 10px' }}>
              <List.Item.Meta
                style={{ textAlign: 'left' }}
                description={
                  <>
                    {item.username == user.username ?
                      <Row>
                        <Col span={8} className="tabletdpadding">
                          {
                            item && item.cos_user && item.cos_user === true ?
                              <span className="cos_user-lightColor">{item.username} </span> :
                              item.userType === 'Clerk' ? <span className="clerk-lightColor">{item.username}</span> :
                                item.userType === 'CHD' ? <span className="chd-lightColor">{item.username} </span> :
                                  item.userType === "DD's & AD's" ? <span className="ads-lightColor">{item.username}</span> :
                                    <></>
                          }
                        </Col>
                        <Col span={5} className="black-color tabletdpadding">
                          {item.initial && item.initial.length
                            ? <div style={{ padding: 0, fontSize: 14, fontWeight: 'normal', marginTop: -2 }} >
                              <Avatar src={<Image preview={false} src={item.initial[0].initial} style={{ width: 32 }} />} />

                            </div>
                            : <Button size={'small'} type="link" style={{ padding: 0, fontSize: 14, fontWeight: 'normal', marginTop: -2 }} onClick={showModal}>

                              {initial
                                ? <Avatar src={<Image preview={false} src={initial} style={{ width: 32 }} />} />
                                : <span> Add Initials </span>
                              }
                            </Button>
                          }


                          <Modal className="add-initial-modal" title={<h3 style={{ margin: '0px' }}>Add Initials</h3>}
                            visible={isModalVisible}
                            cancelButtonProps={{ style: { display: 'none' } }}
                            okButtonProps={{ style: { display: 'none' } }}
                            onCancel={handleCancel}
                          //  onOk={handleOk} onCancel={handleCancel}
                          >
                            <Tabs defaultActiveKey="1" onChange={onChnageTabInModal}>
                              <TabPane tab="Add Sign" key="1">
                                <SignatureCanvas id="initialsignaturecanvascontainer" penColor='black'
                                  ref={canvasRef}
                                  canvasProps={{ width: 470, height: 200, className: 'sigCanvasinitial' }}
                                />
                                <div style={{ marginTop: 10 }}>
                                  <Button className="add-initial-modal-clear-btn" onClick={() => clearSignature()} type={'primary'} ghost>Clear</Button>
                                  <Button onClick={handleOk} style={{ float: 'right' }} type={'primary'} >OK</Button>
                                  <Button onClick={handleCancel} style={{ float: 'right', marginRight: 20 }} type={'primary'} >Cancel</Button>
                                </div>
                              </TabPane>
                              <TabPane tab="Use Saved Signature" key="2">
                                <h3>Saved Signature ({signCount ? signCount : 0})</h3>
                                <List
                                  className="add-initial-signature-list"
                                  itemLayout="horizontal"
                                  dataSource={signatureData}
                                  renderItem={(item: any) => (
                                    <List.Item actions={[<Button onClick={(e) => handleAddSign(e, item)} size={'small'} style={{ float: 'right', marginTop: 5, fontSize: 12 }} type={'primary'}>Add</Button>]}>

                                      <List.Item.Meta
                                        avatar={<Image preview={false} src={item.base64} />}
                                      />
                                    </List.Item>
                                  )}
                                />
                              </TabPane>
                            </Tabs>
                          </Modal>



                        </Col>
                        <Col span={5} className="black-color tabletdpadding" >
                          <span style={{ padding: 0, fontSize: 12, fontWeight: 'normal' }} >
                            {item.initial && item.initial.length ? moment(item.initial[0].created_at).format('DD/MM/Y') : moment().format('DD/MM/Y')}

                          </span>
                        </Col>
                        <Col span={22} className="black-color tabletdpadding">
                          {item.initial && item.initial.length
                            ? <>
                              {item.initial[0].remarks }
                            </>
                            : <>
                            
                              <TextArea placeholder="Input Your Comments or Remarks Here.." onChange={(e) => setRemark(e.target.value)} rows={15} size="small" style={{ lineHeight: 1, minHeight: 10, height: "calc(100% - 45px)" }} />
                              <br />
                              <Button onClick={() => submitInitial()} size={'small'} style={{ float: 'right', marginTop: 5, fontSize: 12 }} type={'primary'}>Save</Button>
                            </>
                          }

                        </Col>
                      </Row>
                      :

                      <Row>
                        <Col span={8} className="tabletdpadding">
                          {/* {item.fullName} */}
                          {
                            item && item.cos_user && item.cos_user === true ?
                              <span className="cos_user-lightColor">{item.surnmae}  </span> :
                              item.userType === 'Clerk' ? <span className="clerk-lightColor">{item.username}  </span> :
                                item.userType === 'CHD' ? <span className="chd-lightColor">{item.username}  </span> :
                                  item.userType === "DD's & AD's" ? <span className="ads-lightColor">{item.username}  </span> :
                                    <></>
                          }
                        </Col>
                        <Col span={5} className="black-color tabletdpadding">
                          {item.initial && item.initial.length ? <Avatar src={<Image preview={false} src={item.initial[0].initial} style={{ width: 32 }} />} /> : '-'}
                        </Col>
                        <Col span={5} className="black-color tabletdpadding">
                          <span style={{ padding: 0, fontSize: 12, fontWeight: 'normal' }} >
                            {item.initial && item.initial.length ? moment(item.initial[0].created_at).format('DD/MM/Y') : '-'}
                          </span>
                        </Col>
                        <Col span={6} className="black-color tabletdpadding">
                          {item.initial && item.initial.length ? item.initial[0].remarks : '-'}
                        </Col>
                      </Row>
                    }

                  </>
                }
              />
            </List.Item>

          )}

        // footer={
        //   zeroStage && <>
        //     {zeroStage.username == user.username ?
        //       <Row>
        //         <Col span={8} className="tabletdpadding">
        //           {/* {zeroStage.username} */}
        //           {
        //             zeroStage && zeroStage.cos_user && zeroStage.cos_user === true ?
        //               <span className="cos_user-lightColor">{zeroStage.username}</span> :
        //               zeroStage && zeroStage.userDetail && zeroStage.userDetail[0] && zeroStage.userDetail[0].userType === 'Clerk' ? <span className="clerk-lightColor">{zeroStage.userDetail[0].fullName}</span> :
        //                 zeroStage && zeroStage.userDetail && zeroStage.userDetail[0] && zeroStage.userDetail[0].userType === 'CHD' ? <span className="chd-lightColor">{zeroStage.userDetail[0].fullName}</span> :
        //                   zeroStage && zeroStage.userDetail && zeroStage.userDetail[0] && zeroStage.userDetail[0].userType === "DD's & AD's" ? <span className="ads-lightColor">{zeroStage.userDetail[0].fullName}</span> :
        //                     <></>
        //           }
        //         </Col>
        //         <Col span={5} className="black-color tabletdpadding">
        //           {zeroStage.initial && zeroStage.initial.length
        //             ? <div style={{ padding: 0, fontSize: 14, fontWeight: 'normal', marginTop: -2 }} >
        //               <Avatar src={<Image preview={false} src={imagePath + zeroStage.initial[0].initial} style={{ width: 32 }} />} />

        //             </div>
        //             : <Button size={'small'} type="link" style={{ padding: 0, fontSize: 14, fontWeight: 'normal', marginTop: -2 }} onClick={showModal}>

        //               {initial
        //                 ? <Avatar src={<Image preview={false} src={initial} style={{ width: 32 }} />} />
        //                 : <span> Add Initials </span>
        //               }
        //             </Button>
        //           }


        //           <Modal className="add-initial-modal" title={<h3 style={{ margin: '0px' }}>Add Initials</h3>}
        //             visible={isModalVisible}
        //             cancelButtonProps={{ style: { display: 'none' } }}
        //             okButtonProps={{ style: { display: 'none' } }}
        //             onCancel={handleCancel}
        //           //  onOk={handleOk} onCancel={handleCancel}
        //           >
        //             <Tabs defaultActiveKey="1" onChange={onChnageTabInModal}>
        //               <TabPane tab="Add Sign" key="1">
        //                 <SignatureCanvas id="initialsignaturecanvascontainer" penColor='black'
        //                   ref={canvasRef}
        //                   canvasProps={{ width: 470, height: 200, className: 'sigCanvasinitial' }}
        //                 />
        //                 <div style={{ marginTop: 10 }}>
        //                   <Button className="add-initial-modal-clear-btn" onClick={() => clearSignature()} type={'primary'} ghost>Clear</Button>
        //                   <Button onClick={handleOk} style={{ float: 'right' }} type={'primary'} >OK</Button>
        //                   <Button onClick={handleCancel} style={{ float: 'right', marginRight: 20 }} type={'primary'} >Cancel</Button>
        //                 </div>
        //               </TabPane>
        //               <TabPane tab="Use Saved Signature" key="2">
        //                 <h3>Saved Signature ({signCount ? signCount : 0})</h3>
        //                 <List
        //                   className="add-initial-signature-list"
        //                   itemLayout="horizontal"
        //                   dataSource={signatureData}
        //                   renderItem={(item: any) => (
        //                     <List.Item actions={[<Button onClick={(e) => handleAddSign(e, item)} size={'small'} style={{ float: 'right', marginTop: 5, fontSize: 12 }} type={'primary'}>Add</Button>]}>

        //                       <List.Item.Meta
        //                         avatar={<Image preview={false} src={SignImagePath + item.signature} />}
        //                       />
        //                     </List.Item>
        //                   )}
        //                 />
        //               </TabPane>
        //             </Tabs>
        //           </Modal>



        //         </Col>
        //         <Col span={5} className="black-color tabletdpadding" >
        //           <span style={{ padding: 0, fontSize: 12, fontWeight: 'normal' }} >
        //             {zeroStage.initial && zeroStage.initial.length ? moment(zeroStage.initial[0].created_at).format('DD/MM/Y') : moment().format('DD/MM/Y')}

        //           </span>
        //         </Col>
        //         <Col span={6} className="black-color tabletdpadding">
        //           {zeroStage.initial && zeroStage.initial.length
        //             ? <>
        //               {zeroStage.initial && zeroStage.initial.length ? zeroStage.initial[0].remarks : '-'}
        //             </>
        //             : <>
        //               <TextArea onChange={(e) => setRemark(e.target.value)} rows={0} size="small" style={{ lineHeight: 1, minHeight: 10, height: "calc(100% - 45px)" }} />
        //               <br />
        //               <Button onClick={() => submitInitial()} size={'small'} style={{ float: 'right', marginTop: 5, fontSize: 12 }} type={'primary'}>Save</Button>
        //             </>
        //           }

        //         </Col>
        //       </Row>
        //       :

        //       <Row>
        //         <Col span={8} className="tabletdpadding">
        //           {/* {zeroStage.username} */}
        //           {
        //             zeroStage && zeroStage.cos_user && zeroStage.cos_user === true ?
        //               <span className="cos_user-lightColor">{zeroStage.username}</span> :
        //               zeroStage && zeroStage.userDetail && zeroStage.userDetail[0] && zeroStage.userDetail[0].userType === 'Clerk' ? <span className="clerk-lightColor">{zeroStage.userDetail[0].fullName}</span> :
        //                 zeroStage && zeroStage.userDetail && zeroStage.userDetail[0] && zeroStage.userDetail[0].userType === 'CHD' ? <span className="chd-lightColor">{zeroStage.userDetail[0].fullName}</span> :
        //                   zeroStage && zeroStage.userDetail && zeroStage.userDetail[0] && zeroStage.userDetail[0].userType === "DD's & AD's" ? <span className="ads-lightColor">{zeroStage.userDetail[0].fullName}</span> :
        //                     <></>
        //           }
        //         </Col>
        //         <Col span={5} className="black-color tabletdpadding">
        //           {zeroStage.initial && zeroStage.initial.length ? <Avatar src={<Image preview={false} src={imagePath + zeroStage.initial[0].initial} style={{ width: 32 }} />} /> : '-'}
        //         </Col>
        //         <Col span={5} className="black-color tabletdpadding">
        //           <span style={{ padding: 0, fontSize: 12, fontWeight: 'normal' }} >
        //             {zeroStage.initial && zeroStage.initial.length ? moment(zeroStage.initial[0].created_at).format('DD/MM/Y') : '-'}
        //           </span>
        //         </Col>
        //         <Col span={6} className="black-color tabletdpadding">
        //           {zeroStage.initial && zeroStage.initial.length ? zeroStage.initial[0].remarks : '-'}
        //         </Col>
        //       </Row>
        //     }
        //   </>
        // }





        />


        {cos_seenStamp && cos_seenStamp.length > 0 &&
          <List
            style={{ width: '100%', paddingLeft: 5, paddingRight: 5, overflow: 'auto' }}
            itemLayout="horizontal"
            dataSource={cos_seenStamp}
            className="upload-doc-seen-stamp-manage"

            renderItem={(item: any) => (

              <List.Item style={{ marginBottom: 10, border: '1px solid #dfe0eb', padding: '15px 10px 15px 10px' }}>
                <List.Item.Meta
                  style={{ textAlign: 'left' }}

                  description={
                    <>

                      <Row>
                        <Col span={8} className="black-color tabletdpadding">
                          {item.username}
                        </Col>
                        <Col span={5} className="black-color tabletdpadding">
                          {item.initial && item.initial.length ? <Avatar src={<Image preview={false} src={item.initial[0].initial} style={{ width: 32 }} />} /> : '-'}
                        </Col>
                        <Col span={5} className="black-color tabletdpadding">
                          <span style={{ padding: 0, fontSize: 12, fontWeight: 'normal' }} >
                            {item.initial && item.initial.length ? moment(item.initial[0].created_at).format('DD/MM/Y') : '-'}
                          </span>
                        </Col>
                        <Col span={6} className="black-color tabletdpadding">
                          {item.initial && item.initial.length ? item.initial[0].remarks : '-'}
                        </Col>
                      </Row>



                    </>
                  }
                />
              </List.Item>

            )}

          />
        }


        {/* Previous Comments */}
{preremarksData.length >0 && 
<div>
<h4>REMARKS FROM THE PARENT PROCESS</h4>
        <List
    itemLayout="horizontal"
    dataSource={preremarksData}
    renderItem={(item: any) => (
      <List.Item>
        <List.Item.Meta
       
          title={item.username.toUpperCase()}
          description={item.remarks}
        />
      </List.Item>
    )}
  />
  
  </div>}



      </div>

    </>
  );

}